<div class="scroll-downs">
  <div class="mousey mt-4">
    <div class="scroller"></div>
  </div>
</div>